import type { FC, ReactNode } from 'react';
import { useRootZoom } from '../hooks/useRootZoom';

/** 无 UI：仅挂载根节点 zoom 适配 */
export const RootZoomBridge: FC<{ children: ReactNode }> = ({ children }) => {
  useRootZoom();
  return <>{children}</>;
};
